import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import auth from './auth';
import dbcalls from './actions';

export default createStore({
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {},
    modules: {
        auth,
        dbcalls,
    },
    plugins: [createPersistedState()],
});
